import { AnimatePresence } from 'framer-motion';
import { Fragment, PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { GeniePadElementsSettingItem } from '../../../../../api/pushGenie';
import { Actions } from '../../../../../store/actions';
import { upsertGenieSetting } from '../../../../../store/actions/session';
import { GlobalState } from '../../../../../store/reducers';
import { getGenieSetting, getMedTypeIds } from '../../../../../store/selectors/session';
import { settingsIcon } from '../../../../common/Icons';
import { PAD_V2_CONTAINER } from '../PadContainer';
import MedicationConfigPanel from './MedicationConfigPanel';

type State = {
    isVisible: boolean;
};

type Props = {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    elements: GeniePadElementsSettingItem[];
    medTypeIds: string[];
    isDoseCalculatorAvailable: boolean;
    medRouteEnabled: boolean;
};

class ConfigureMxTable extends PureComponent<Props> {
    state: State = {
        isVisible: false,
    };
    settingsIcon = settingsIcon('fill-neutral-3');
    container = (): HTMLElement => document.getElementById(PAD_V2_CONTAINER) || document.body;

    close = (): void =>
        this.setState({
            isVisible: false,
        });

    open = (): void =>
        this.setState({
            isVisible: true,
        });

    save = (
        elements: GeniePadElementsSettingItem[],
        medTypeIds: string[],
        isDoseCalculatorAvailable: boolean,
        medRouteEnabled: boolean,
    ): void => {
        const { dispatch } = this.props;
        dispatch(
            upsertGenieSetting({
                medElements: elements,
                medTypeIds: medTypeIds,
                isDoseCalculatorAvailable: isDoseCalculatorAvailable,
                medRouteEnabled: medRouteEnabled,
            }),
        );
        this.close();
        return;
    };

    render(): ReactNode {
        const { isVisible } = this.state;
        const { elements, medTypeIds, isDoseCalculatorAvailable } = this.props;
        return (
            <Fragment>
                <AnimatePresence>
                    {isVisible && (
                        <MedicationConfigPanel
                            closeMe={this.close}
                            onUpdate={this.save}
                            config={elements}
                            medTypeIds={medTypeIds}
                            isDoseCalculatorAvailable={isDoseCalculatorAvailable}
                            medRouteEnabled={this.props.medRouteEnabled}
                        />
                    )}
                </AnimatePresence>
                <span
                    onClick={this.open}
                    className="flex justify-center items-center bg-darwin-neutral-50 text-darwin-neutral-800 h-24 w-24 rounded-full cursor-pointer"
                >
                    {this.settingsIcon}
                </span>
            </Fragment>
        );
    }
}

export default connect((state: GlobalState) => ({
    elements: getGenieSetting(state, 'medElements') as GeniePadElementsSettingItem[],
    medTypeIds: getMedTypeIds(state),
    isDoseCalculatorAvailable: getGenieSetting(state, 'isDoseCalculatorAvailable') as boolean,
    medRouteEnabled: getGenieSetting(state, 'medRouteEnabled') as boolean,
}))(ConfigureMxTable);
